import moment from 'moment';

export function getDateDiff(date) {
	const a = moment(date);
	const b = moment();

	return b.diff(a, 'days');
}

export function dateValidationCheck(value) {
	return moment(value).isValid();
}

export function getQueryParams(key) {
	const queryString = window.location.search;
	const parameters = new URLSearchParams(queryString);

	return parameters.get(key);
}
